<div class="chart-card" *transloco="let t; prefix: 'costTracking.distribution'">
  <div class="chart-header">
    <h3 class="chart-title">{{ title }}</h3>
  </div>

  <div class="chart-body">
    @if (isLoading) {
      <div class="card-loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    } @else if (!hasData()) {
      <div class="d-flex align-items-center justify-content-center no-data">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      <div class="distribution-content">
        <div class="chart-section">
          <div class="donut-wrapper">
            <app-donut-chart
              [data]="chartData"
              [width]="160"
              [height]="160"
              [innerRadiusRatio]="0.6"
              [variableArcWidths]="false"
              [showPercentageOnHover]="true"
              [showPercentageAlways]="true"
              [percentageFontSize]="11"
              (segmentHover)="onSegmentHover($event)">
            </app-donut-chart>

            <div class="center-text">
              <div class="center-label">{{ t('score') }}</div>
              <div class="center-value" [class.hovered]="hoveredPercentage !== null">
                {{ getCenterPercentage() }}
              </div>
            </div>
          </div>

          <div class="chart-legend">
            <div class="legend-item" [class.highlighted]="hoveredSegmentName === 'Preventive'" [class.dimmed]="hoveredSegmentName !== null && hoveredSegmentName !== 'Preventive'">
              <span class="legend-dot preventive"></span>
              <span class="legend-label">{{ t('preventive') }}</span>
            </div>
            <div class="legend-item" [class.highlighted]="hoveredSegmentName === 'Reactive'" [class.dimmed]="hoveredSegmentName !== null && hoveredSegmentName !== 'Reactive'">
              <span class="legend-dot reactive"></span>
              <span class="legend-label">{{ t('reactive') }}</span>
            </div>
          </div>
        </div>

        <div class="stats-section">
          <div class="stat-group reactive" [class.highlighted]="hoveredSegmentName === 'Reactive'" [class.dimmed]="hoveredSegmentName !== null && hoveredSegmentName !== 'Reactive'">
            <div class="stat-header">
              <span class="stat-label">{{ t('reactiveCosts') }}</span>
            </div>
            <div class="stat-value">
              <span class="stat-percent">{{ reactivePercentage }}%</span> - {{ formatCost(reactiveCost) }}
            </div>
            <div class="stat-sublabel">{{ t('unplannedRepairs', { count: reactiveCount }) }}</div>
          </div>

          <div class="stat-group preventive" [class.highlighted]="hoveredSegmentName === 'Preventive'" [class.dimmed]="hoveredSegmentName !== null && hoveredSegmentName !== 'Preventive'">
            <div class="stat-header">
              <span class="stat-label">{{ t('preventiveCosts') }}</span>
            </div>
            <div class="stat-value">
              <span class="stat-percent">{{ preventivePercentage }}%</span> - {{ formatCost(preventiveCost) }}
            </div>
            <div class="stat-sublabel">{{ t('servicesCompleted', { count: preventiveCount }) }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>